<template>
    <div class="benefits-home-view">
        <navigation-tabs />
        <navigation ref="navigation" />
        <benefit-header :title="content.title" :description="content.description" />
        <benefit-filters @update-filters="handleFilterUpdate" />
        <div class="benefits-content-wrapper container">
            <template v-if="filteredBenefits.length > 0">
                <benefit-card 
                    v-for="item in displayedBenefits" 
                    :key="item.id"
                    :type="item.benefit_type"
                    :slug="item.attributes.slug"
                    :title="item.attributes.title"
                    :previewDescription="item.attributes.preview_description"
                    :segment="item.attributes.filters.segment"
                    :cardType="item.attributes.filters.card_type"
                    :previewImage="item.attributes.preview_image?.data?.attributes?.ext ? getAssetUrl(item.attributes.preview_image.data.attributes.url) : null"
                    :logoImage="item.attributes.logo_image"
                />
            </template>
            <div v-else class="benefits-empty-state">
                <svg class="benefits-empty-state-icon" xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="none" viewBox="0 0 48 48">
                <path fill="#1a2030" d="M24 2.5a21.5 21.5 0 1 1 0 43 21.5 21.5 0 0 1 0-43M23 20a2 2 0 1 0 0 4v9a2 2 0 1 0 4 0V22.7q-.1-.7-.8-1.7a3 3 0 0 0-1.8-1zm1-6a2 2 0 1 0 0 4 2 2 0 0 0 0-4"/>
                </svg>
                <p>No encontramos beneficios relacionados a tu búsqueda.</p>
            </div>
        </div>
        <div class="benefits-view-more-box">
            <button v-if="hasMoreCards" @click="loadMore" class="cta benefits-view-more">Ver más</button>
        </div>
        <modal-cookies ref="modal-cookies" />
        <footer-section />
    </div>
</template>

<script>
// Mixins
import ViewMixin from "@/mixins/viewMixin"

// Components
import NavigationTabs from '@/components/global/NavigationTabs.vue'
import Navigation from "@/components/global/navigation"
import Footer from "@/components/global/footer"

import benefitHeader from "@/components/benefit/benefit-header"
import benefitFilters from "@/components/benefit/benefit-filters"
import benefitCard from "@/components/benefit/benefit-card"

// Components Global
import ModalCookies from "@/components/global/ModalCookies"

export default {
    name: 'home-benefit',
    mixins: [ViewMixin],
    data: ()=>{
        return {
            visible: true,
            activeFilters: {
                segment: null,
                card_type: null,
                day_of_week: null
            },
            displayLimit: 8,
            content: {
                benefits_grid: [],
            }
        }
    },
    components: {
        'navigation-tabs':NavigationTabs,
        'navigation': Navigation,
        'modal-cookies': ModalCookies,
        'footer-section': Footer,

        'benefit-header': benefitHeader,
        'benefit-filters':benefitFilters,
        'benefit-card':benefitCard
    },
    beforeMount() {
        this.content = this.$store.state.page["home-benefit"].data.attributes
        this.wording = this.$store.state.wording.data.attributes
    },
    mounted () {
        this.$nextTick(()=>{
                this.show()
                this.$refs.navigation.activate("/beneficios")
            })
    },
    computed: {
        filteredBenefits() {
            if (!this.content.benefits_grid) return [];

            let allCards = [];
            this.content.benefits_grid.forEach(list => {
                list.benefits.data.forEach(item => {
                    allCards.push({
                        ...item,
                        benefit_type: list.benefit_type
                    });
                });
            });

            return allCards.filter(item => {
                const f = item.attributes.filters;
                const matchSegment = !this.activeFilters.segment || f.segment === this.activeFilters.segment;
                const matchType = this.activeFilters.card_type === null ||
                    (f.card_type[this.activeFilters.card_type] && Object.values(f.card_type[this.activeFilters.card_type]).includes(true));
                const matchDay = this.activeFilters.day_of_week === null ||
                    (f.day_of_week[this.activeFilters.day_of_week] && Object.values(f.day_of_week[this.activeFilters.day_of_week]).includes(true));

                return matchSegment && matchType && matchDay;
            });
        },

        displayedBenefits() {
            return this.filteredBenefits.slice(0, this.displayLimit);
        },

        hasMoreCards() {
            return this.filteredBenefits.length > this.displayLimit;
        }
    },
    methods: {
        show() {
            this.$refs.navigation.hidden = false
            this.$refs.navigation.forcedLight = true
        },
        handleFilterUpdate(newFilters) {    
            this.activeFilters = newFilters;
        },
        loadMore() {
            this.displayLimit = this.filteredBenefits.length;
        }
    }
}
</script>

<style lang="less" scoped>
    @import "../styles/vars.less";
    .benefits-home-view{
        background: @grey;
    }
    .benefits-content-wrapper{
        display: grid;
        grid-template-columns: repeat(6, 1fr);
        gap: 62px 32px;
    }
    .benefits-empty-state{
        font-family: @bold;
        font-size: 1.5rem;
        grid-column: span 6;
        padding: 20% 0;
        text-align: center;
    }
    .benefits-empty-state-icon{
        margin-bottom: 16px;
    }
    .benefits-view-more-box{
        position: relative;
        margin: 32px auto 86px;
        text-align: center;
    }
    .benefits-view-more{
        z-index: 1;
        padding: 12px 60px 12px 30px;
        width: max-content;
        max-width: 180px;
    }

    @media screen and (max-width: @tablet) {
        .benefits-content-wrapper{
            max-width: inherit;
            gap: 16px;
            grid-template-columns: 1fr;
        }
    }
</style>